import styles from "../../../pages/subscriptions/mySubscription/MySubscription.module.css";
import { createSubscriptionFeatures } from "../../../utils/helpers/subscriptions/subscriptionFeatures";

export default function BenefitsCard({ entitlements, t, plan, lang }) {
  return (
    <div className={styles.benefitsCard}>
      <h3 className={styles.benefitsTitle}>{t("plan_details")}</h3>
      <div className={styles.benefitsGrid}>
        {createSubscriptionFeatures({ entitlements, plan, t, lang }).map((b, i) => (
          <div key={i} className={styles.benefitItem}>

            {!b.statusText && (
              b.status === "locked" ? (
                <img src="/assets/subscriptions/locked.svg" alt="" width={18} height={18}/> 
              ) : (
                <img src="/assets/subscriptions/active.svg" alt="" width={18} height={18}/>
              )
            )}
            <span>{b.text}</span>

            {b.statusText && (
              <span className={styles.statusText}>{`(${b.statusText})`}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}